import React from "react";
import Loading from "react-fullscreen-loading";
import './style.css'

const FullScreenLoader = (props) => {
  return <div className = "custom-loading"><Loading loading={props.loading} background="#1F1E21" loaderColor="white" /></div>;
}

export default FullScreenLoader;